import { apiClient } from '@/api/client'

/** 読書ノート本文の TextDocument の entity_type（entity_id は作品 ID） */
export const BOOK_NOTE_ENTITY_TYPE = 'product_note'

export type BookNoteListItem = {
  product_id: number
  title: string
  domain: string
  preview: string
  updated_at: string
}

export type BookNoteInfo = {
  product_id: number
  title: string
  domain: string
  highlight_count: number
}

/** 本文のある読書ノートを更新日時の降順で取得 */
export const listBookNotes = async (): Promise<BookNoteListItem[]> => {
  const res = await apiClient.get<{ items: BookNoteListItem[] }>('/book-notes')
  return res.data.items
}

/** 読書ノートの画面に出す作品名とハイライト件数を取得 */
export const getBookNoteInfo = async (productId: number): Promise<BookNoteInfo> => {
  const res = await apiClient.get<BookNoteInfo>(`/book-notes/${productId}`)
  return res.data
}
